import { Button, Col, Divider, Form, Input, message, Modal, Row, Select, Spin, Tooltip } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { IModuleInfo, ProgressParamType } from '../../../../redux/progress/module/moduleInterface';
import { IState } from '../../../../redux/store';
import RealTimeTitleBlock from '../RealTimeTitleBlock';
import dateFormat from '../../../../utils/dateFormat';
import RealTimeFileItem from '../RealTimeFileItem';
import RealTimeDataPicker from '../RealTimeDataPicker';
import httpRequest from '../../../../utils/HttpRequest';
import { useParams } from 'react-router';
import { TECHNIC_PREFIX } from '../../../../config/technicPrefix';
import { urls } from '../../../../config/url';
import { setActiveLine, updateLines } from '../../../../redux/progress/line/lineAction';
import useUpdateLine from '../../header/useLine';
import { ILines } from '../../../../redux/progress/line/lineReducer';
import { IModuleParams } from '../../../../redux/progress/param/paramReducer';
import { updateParam } from '../../../../redux/progress/param/paramAction';
import store from "../../../../redux/store";
import JobStatusViewer from '../../ReflectModule/moduleParam/paramSubmit/JobViewer';
const { Option } = Select;

export interface RealTimeParamsPropies {
    module?: IModuleInfo;
    activeProject: string;
    username: string;
    setActiveLine: (name: string) => void;
    updateLines: (lines: ILines) => void,
    params: IModuleParams;
    updateParam: (params: IModuleParams) => void;
    cancalData: any,
    btnStatus: (params: boolean) => void;
    tablebtn: boolean;
    empty: (params: boolean) => void;
    lineName: string,
}

interface FieldData {
    name: string | number | (string | number)[];
    value?: any;
    touched?: boolean;
    validating?: boolean;
    errors?: string[];
}

function params2FieldData(params: IModuleParams): FieldData[] {
    const fieldData: FieldData[] = [];
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const param = params[key];
            fieldData.push({
                name: key,
                value: param,
            });
        }
    }
    return fieldData;
}

function fieldData2Params(fieldData: FieldData[]): IModuleParams {
    const params: IModuleParams = {};
    fieldData.forEach(field => {
        params[(field.name as string[])[0]] = field.value;
    }
    );
    return params;
}

function RealTimeParams(props: RealTimeParamsPropies) {
    // 表单信息
    // const [fields, setFields] = useState<FieldData[]>([]);
    // 模块类别
    let { spec, tech } = useParams<{ spec: string, tech: string }>();
    const [startTime, setStartTime] = useState<any>()
    const [endTime, setEndTime] = useState<any>()


    const [formData, setFormData] = useState<any>() // 表格内数据

    const [num, setNum] = useState<any>('');
    const timeRef = useRef()
    // 是否重复提交弹窗展示
    const [modelSHow, setModel] = useState<boolean>(false)


    const [btnStart, setBtnStart] = useState<boolean>(false) //开始
    const [btnStop, setBtnStop] = useState<boolean>(true) //停止
    const [btnReset, setBtnReset] = useState<boolean>(true) //重测
    const [btnEdit, setBtnEdit] = useState<boolean>(true) //修改参数
    const [btnResetSub, setbtnResetSub] = useState<boolean>(true) //重新提交

    const [paramDis, setParamsDis] = useState<boolean>(false) //模块参数是否是disable状态

    const [resetData, setResetData] = useState<boolean>(false) //接口传值判断是否是重复数据

    const [tableDis, setTableDis] = useState<boolean>(false)
    const [form] = Form.useForm();
    const [txt, setTxt] = useState<string>()
    useEffect(() => {
        if (props.btnStatus) {
            props.btnStatus(tableDis)
        }
    }, [tableDis])

    useEffect(() => {
        if (num === '0:0') {

            clearInterval(timeRef.current)
            setNum(0)
            setBtnStart(false)
            setBtnStop(true)
            setBtnReset(true)
            setParamsDis(true)
            setTableDis(false)
            submit()
        }
    }, [num])

    // 更新测线
    const updateLines = useUpdateLine(props.username, props.activeProject, props.updateLines, tech);

    // 默认信息
    const getDefault = useCallback(() => {
        if (props.module === undefined) return {};
        const params = props.module.PRO_MODULE_PARAMS;
        const defaultVal: { [key: string]: any } = {
            job_name: `${props.module.PRO_MODULE_NAME}-${dateFormat("YYYYmmdd:HH:MM:SS", new Date())}`
        };

        params.forEach((param) => {
            switch (param.PARAMTYPE) {
                case ProgressParamType.DATE:
                    defaultVal[param.PARAMNAME] = param.PARAMDEFAULTVALUE === '' ? new Date().valueOf() : param.PARAMDEFAULTVALUE;
                    break;
                default:
                    defaultVal[param.PARAMNAME] = param.PARAMDEFAULTVALUE;
                    break;
            }
        })
        return { ...defaultVal, ...props.params };

    }, [props.module, props.params]);

    // 如果获取不到列表显示加载中
    if (!props.module) {
        return <Spin />
    }
    // 参数信息
    const params = props.module.PRO_MODULE_PARAMS;

    //生成表单
    const items = params.slice(0, params.length / 2).map(param => {
        let itemInput = <></>

        if (param.HIDE === 'YES') return <></>

        if (param.PARAMALIASNAME === '测线名称') {
            param.PARAMDEFAULTVALUE = props.lineName
        }
        switch (param.PARAMTYPE) {
            case ProgressParamType.FILE:
                itemInput = <RealTimeFileItem param={param} />
                break;
            case ProgressParamType.ENUM:
                const enumValueList = (param.PARAMDEVALUERANGE as string).split(";");
                itemInput = <Select disabled={paramDis}>
                    {enumValueList.map(val => <Option key={val} value={val} >{val}</Option>)}
                </Select>
                break;
            case ProgressParamType.DATE:
                itemInput = <RealTimeDataPicker />
                break;
            default:
                itemInput = <>
                    <Input disabled={paramDis} defaultValue={param.PARAMDEFAULTVALUE} onBlur={(e) => {
                        if (param.PARAMMAX && param.PARAMMIN) {
                            let max = param.PARAMMAX
                            let min = param.PARAMMIN
                            if (param.PARAMMAX > e.target.value && param.PARAMMIN < e.target.value) {
                                setTxt('')

                            } else {
                                setTxt('输入的内容最大值' + max + ',' + '输入的内容最小值' + min)
                                props.updateParam({ errortxt: '输入的内容最大值' + max + ',' + '输入的内容最小值' + min });
                            }
                        }
                    }} />

                    {
                        param.PARAMMAX && param.PARAMMIN && txt != '' ? <span style={{ color: 'red' }}>{txt}</span> : ''
                    }
                </>
                break;
        }

        return <Tooltip title={String(param.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
            <FormItem
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 14 }}
                label={param.PARAMALIASNAME}
                name={param.PARAMNAME}
                style={{
                    // fontWeight: 'bolder',
                    marginBottom: '0.2vh',
                    fontFamily: '微软雅黑'
                }}
                key={param.PARAMNAME}

            >
                {itemInput}
            </FormItem>
        </Tooltip>
    })
    const items1 = params.slice(params.length / 2, params.length).map(param => {

        let itemInput = <></>

        if (param.HIDE === 'YES') return <></>
        if (param.PARAMALIASNAME === '测线名称') {
            param.PARAMDEFAULTVALUE = props.lineName
        }
        switch (param.PARAMTYPE) {
            case ProgressParamType.FILE:
                itemInput = <RealTimeFileItem param={param} />
                break;
            case ProgressParamType.ENUM:
                const enumValueList = (param.PARAMDEVALUERANGE as string).split(";");
                itemInput = <Select disabled={paramDis}>
                    {enumValueList.map(val => <Option key={val} value={val} >{val}</Option>)}
                </Select>
                break;
            case ProgressParamType.DATE:
                itemInput = <RealTimeDataPicker />
                break;
            default:
                itemInput = <>
                    {
                        param.PARAMALIASNAME === '测线名称' ? <input value={props.lineName} /> : <Input disabled={paramDis} defaultValue={param.PARAMDEFAULTVALUE} onBlur={(e) => {
                            if (param.PARAMMAX && param.PARAMMIN) {
                                let max = param.PARAMMAX
                                let min = param.PARAMMIN
                                if (param.PARAMMAX > e.target.value && param.PARAMMIN < e.target.value) {
                                    setTxt('')

                                } else {
                                    setTxt('输入的内容最大值' + max + ',' + '输入的内容最小值' + min)
                                    props.updateParam({ errortxt: '输入的内容最大值' + max + ',' + '输入的内容最小值' + min });
                                }
                            }
                        }} />
                    }
                    {
                        param.PARAMMAX && param.PARAMMIN && txt != '' ? <span style={{ color: 'red' }}>{txt}</span> : ''
                    }
                </>
                break;
        }

        return <Tooltip title={String(param.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
            <FormItem
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 14 }}
                label={param.PARAMALIASNAME}
                name={param.PARAMNAME}
                style={{
                    // fontWeight: 'bolder',
                    marginBottom: '0.2vh',
                    fontFamily: '微软雅黑'
                }}
                key={param.PARAMNAME}

            >
                {itemInput}
            </FormItem>
        </Tooltip>
    })




    const time = (time: any) => {
        if (time === '' || time === undefined) {
            return ''
        } else {
            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var dates = time.getDate();
            var hour = time.getHours()
            var minutes = time.getMinutes()
            var seconds = time.getSeconds()
            let arr = year + '-' + month + '-' + dates + '  ' + hour + ':' + minutes + ':' + seconds
            return arr

        }
    }

    const submit = () => {
        let edit = false

        httpRequest(urls.submitJob, {
            edit: resetData,
            USER_NAME: props.username,
            PROJECTNAME: props.activeProject,
            PRO_MODULE_CLASS: spec,
            PRO_MODULE_CATEGORY: tech,
            PRO_MODULE_NAME: props.module!.PRO_MODULE_NAME,
            JOB_NAME: (formData as any)?.job_name,
            PARAMS: formData,
            PROCESSMODULE_EXECORDER: props.module!.PRO_MODULE_EXECORDER,
            TECHNIC_PREFIX: (TECHNIC_PREFIX as any)[tech],
            PRO_MODULE_TECHTYPE: props.module!.PRO_MODULE_TECHTYPE,
            PRO_MODULE_LANGUAGE: props.module!.PRO_MODULE_LANGUAGE,
            PRO_MODULE_MEDIA: props.module!.PRO_MODULE_MEDIA,
            FLOWTYPE: "fixtime",
            STARTDATETIME: new Date(startTime).valueOf(),
            ENDDATETIME: new Date().valueOf(),
            surveydata: props.cancalData
        }).then((res: { data: { errno: number; errmsg: any; }; }) => {
            if (res.data.errno !== 0) {
                Modal.error({
                    title: '提交失败',
                    content: res.data.errmsg,
                });
            } else {
                message.success('提交成功');
                setStartTime('')
                setEndTime('')
                setBtnEdit(false)
                setResetData(false)
                if (formData!.proj_name && formData.proj_name !== props.activeProject) {
                    updateLines().then(() => props.setActiveLine(formData.proj_name));
                }
            }
        }).catch(err => {
            Modal.error({
                title: '提交失败',
                content: err.message,
            });
        })
    }



    return <RealTimeTitleBlock title={'模块参数'}>
        <Form
            style={{ width: '100%' }}
            name={'Params List'}
            initialValues={getDefault()}
            labelAlign={'right'}
            form={form}

            onFinish={async (values) => {

                if (btnResetSub === false) {
                    setBtnStart(false)
                    setBtnStop(true)
                    setBtnReset(true)
                    setBtnEdit(true)
                    setbtnResetSub(true)
                    setParamsDis(true)

                    setTableDis(false)
                    if (props.empty) {
                        props.empty(false)
                    }
                    httpRequest(urls.submitJob, {
                        edit: true,
                        USER_NAME: props.username,
                        PROJECTNAME: props.activeProject,
                        PRO_MODULE_CLASS: spec,
                        PRO_MODULE_CATEGORY: tech,
                        PRO_MODULE_NAME: props.module!.PRO_MODULE_NAME,
                        JOB_NAME: (values as any)?.job_name,
                        PARAMS: values,
                        PROCESSMODULE_EXECORDER: props.module!.PRO_MODULE_EXECORDER,
                        TECHNIC_PREFIX: (TECHNIC_PREFIX as any)[tech],
                        PRO_MODULE_TECHTYPE: props.module!.PRO_MODULE_TECHTYPE,
                        PRO_MODULE_LANGUAGE: props.module!.PRO_MODULE_LANGUAGE,
                        PRO_MODULE_MEDIA: props.module!.PRO_MODULE_MEDIA,
                        FLOWTYPE: "fixtime",
                        STARTDATETIME: new Date().valueOf(),
                        ENDDATETIME: new Date().valueOf(),
                        surveydata: [{ devno: -999, line: -999, point: -999 }]
                    }).then((res: { data: { errno: number; errmsg: any; }; }) => {
                        if (res.data.errno !== 0) {
                            Modal.error({
                                title: '提交失败',
                                content: res.data.errmsg,
                            });
                        } else {
                            message.success('提交成功');
                            setStartTime('')
                            setEndTime('')
                            setBtnEdit(true)
                            setResetData(false)
                        }
                    }).catch(err => {
                        Modal.error({
                            title: '提交失败',
                            content: err.message,
                        });
                    })
                } else {
                    if (num === '' || num === 0) {
                        return message.error('请输入采集时间')
                    }
                    for (const param of params) {
                        if (values[param.PARAMNAME] === undefined || values[param.PARAMNAME] === '') {
                            Modal.error({
                                title: '参数错误',
                                content: `参数'${param.PARAMALIASNAME}'不能为空`,
                            });
                            return;
                        }
                    }


                    if (props.cancalData.length === 0) {
                        message.error("线号点号表格内容不能为空")
                        return
                    }
                    if (props.tablebtn === false) {
                        message.error("请检查表格数据是否进行提交，提交按钮是否为灰色>")
                        return
                    }

                    let survey: any[] = []
                    props.cancalData.map((item: any, i: any) => {
                        if (item.devno === undefined || item.devno === '') {

                        } else {
                            survey.push(item)
                        }
                    })
                    let resArr: never[] = []
                    setBtnStop(false)
                    setBtnReset(false)
                    setBtnStart(true)
                    setParamsDis(true)
                    setTableDis(true)
                    httpRequest(urls.loadfixjoballsurvey, {
                        edit: false,
                        USER_NAME: props.username,
                        PROJECTNAME: props.activeProject,
                        PRO_MODULE_CLASS: spec,
                        PRO_MODULE_CATEGORY: tech,
                        PRO_MODULE_NAME: props.module!.PRO_MODULE_NAME,
                        JOB_NAME: values.job_name,
                        PARAMS: values,
                        PROCESSMODULE_EXECORDER: props.module!.PRO_MODULE_EXECORDER,
                        TECHNIC_PREFIX: (TECHNIC_PREFIX as any)[tech],
                        PRO_MODULE_TECHTYPE: props.module!.PRO_MODULE_TECHTYPE,
                        PRO_MODULE_LANGUAGE: props.module!.PRO_MODULE_LANGUAGE,
                        PRO_MODULE_MEDIA: props.module!.PRO_MODULE_MEDIA,
                        FLOWTYPE: "fixtime",
                        STARTDATETIME: new Date().valueOf(),
                        ENDDATETIME: new Date(endTime).valueOf(),
                        surveydata: survey
                    }).then((res: { data: { errno: number; errmsg: any; data: any }; }) => {
                        if (res.data.errno !== 0) {
                            Modal.error({
                                title: '失败',
                                content: res.data.errmsg,
                            });
                        } else {
                            resArr = res.data.data

                            if (resArr.length != 0) {
                                // 接口返回的数据
                                let checkarr: any = []
                                for (let index = 0; index < resArr.length; index++) {
                                    const element: { devno: string, line: number, point: number } = resArr[index];
                                    checkarr.push(element.line * 1000 + element.point)
                                }

                                let cancalarr = []
                                for (let index = 0; index < props.cancalData.length; index++) {
                                    const element: { devno: string, line: number, point: number } = props.cancalData[index];
                                    cancalarr.push(element.line * 1000 + element.point)
                                }

                                let arr = [...checkarr, ...cancalarr]
                                for (var i = 0; i < arr.length; i++) {
                                    if (arr.indexOf(arr[i]) != i) {
                                        setModel(true)
                                        return
                                    }
                                }

                            }


                        }
                    }).catch(err => {

                        Modal.error({
                            title: '失败',
                            content: err.message,
                        });
                        return
                    })
                    setFormData(values)



                    const nowData = new Date()
                    setStartTime(nowData)

                    let time = Number(num.split(':')[0]) * 60
                    let times = time
                    if (timeRef === undefined) {
                        return
                    }

                    (timeRef as any).current = setInterval(() => {


                        times -= 1
                        let m = Math.floor(times / 60)
                        let s = (times % 60)
                        setNum(m + ':' + s)
                    }, 1000)
                }






            }}
            fields={params2FieldData(props.params)}
            onFieldsChange={(_, allFields) => {

                updateParam(fieldData2Params(allFields));
            }}
        >

            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div>
                    {
                        params.slice(0, params.length / 2).map((item, i) => {
                            const enumValueList = (item.PARAMDEVALUERANGE as string).split(";");
                            return (
                                item.PARAMTYPE === 'file' ? <Tooltip title={String(item.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                                    <FormItem
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                        label={item.PARAMALIASNAME}
                                        name={item.PARAMNAME}
                                        style={{
                                            // fontWeight: 'bolder',
                                            marginBottom: '0.2vh',
                                            fontFamily: '微软雅黑'
                                        }}
                                        key={item.PARAMNAME}

                                    >
                                        <RealTimeFileItem param={item} />
                                    </FormItem>
                                </Tooltip> : item.PARAMTYPE === 'enum' ? <>

                                    <Tooltip title={String(item.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                                        <FormItem
                                            labelCol={{ span: 10 }}
                                            wrapperCol={{ span: 14 }}
                                            label={item.PARAMALIASNAME}
                                            name={item.PARAMNAME}
                                            style={{
                                                // fontWeight: 'bolder',
                                                marginBottom: '0.2vh',
                                                fontFamily: '微软雅黑'
                                            }}
                                            key={item.PARAMNAME}

                                        >

                                            <Select disabled={paramDis}>
                                                {enumValueList.map(val => <Option key={val} value={val} >{val}</Option>)}
                                            </Select>
                                        </FormItem>
                                    </Tooltip>
                                </> : item.PARAMTYPE === 'datetime' ? <Tooltip title={String(item.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                                    <FormItem
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                        label={item.PARAMALIASNAME}
                                        name={item.PARAMNAME}
                                        style={{
                                            // fontWeight: 'bolder',
                                            marginBottom: '0.2vh',
                                            fontFamily: '微软雅黑'
                                        }}
                                        key={item.PARAMNAME}

                                    >

                                        <RealTimeDataPicker />
                                    </FormItem>
                                </Tooltip> : <Tooltip title={String(item.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                                    <FormItem
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                        label={item.PARAMALIASNAME}
                                        name={item.PARAMNAME}
                                        style={{
                                            // fontWeight: 'bolder',
                                            marginBottom: '0.2vh',
                                            fontFamily: '微软雅黑'
                                        }}
                                        key={item.PARAMNAME}
                                        rules={[
                                            { required: item.PARAMMAX && item.PARAMMIN, message: '请输入内容' },
                                            {
                                                validator(_, value) {
                                                    let max = item.PARAMMAX
                                                    let min = item.PARAMMIN
                                                    if (item.PARAMMAX && item.PARAMMIN) {
                                                        if (value < max && value > min) {
                                                            return Promise.resolve();
                                                        } else {
                                                            return Promise.reject(`取值范围` + min + `-` + max);
                                                        }
                                                    } else {
                                                        return Promise.resolve();
                                                    }

                                                },
                                            },
                                        ]}
                                    >

                                        <Input />
                                    </FormItem>
                                </Tooltip>
                            )
                        })
                    }
                </div>
                <div>
                    {
                        params.slice(params.length / 2, params.length).map((item, i) => {
                            const enumValueList = (item.PARAMDEVALUERANGE as string).split(";");
                            return (
                                item.PARAMTYPE === 'file' ? <Tooltip title={String(item.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                                    <FormItem
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                        label={item.PARAMALIASNAME}
                                        name={item.PARAMNAME}
                                        style={{
                                            // fontWeight: 'bolder',
                                            marginBottom: '0.2vh',
                                            fontFamily: '微软雅黑'
                                        }}
                                        key={item.PARAMNAME}

                                    >
                                        <RealTimeFileItem param={item} />
                                    </FormItem>
                                </Tooltip> : item.PARAMTYPE === 'enum' ? <>

                                    <Tooltip title={String(item.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                                        <FormItem
                                            labelCol={{ span: 10 }}
                                            wrapperCol={{ span: 14 }}
                                            label={item.PARAMALIASNAME}
                                            name={item.PARAMNAME}
                                            style={{
                                                // fontWeight: 'bolder',
                                                marginBottom: '0.2vh',
                                                fontFamily: '微软雅黑'
                                            }}
                                            key={item.PARAMNAME}

                                        >

                                            <Select disabled={paramDis}>
                                                {enumValueList.map(val => <Option key={val} value={val} >{val}</Option>)}
                                            </Select>
                                        </FormItem>
                                    </Tooltip>
                                </> : item.PARAMTYPE === 'datetime' ? <Tooltip title={String(item.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                                    <FormItem
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                        label={item.PARAMALIASNAME}
                                        name={item.PARAMNAME}
                                        style={{
                                            // fontWeight: 'bolder',
                                            marginBottom: '0.2vh',
                                            fontFamily: '微软雅黑'
                                        }}
                                        key={item.PARAMNAME}

                                    >

                                        <RealTimeDataPicker />
                                    </FormItem>
                                </Tooltip> : <Tooltip title={String(item.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                                    <FormItem
                                        labelCol={{ span: 10 }}
                                        wrapperCol={{ span: 14 }}
                                        label={item.PARAMALIASNAME}
                                        name={item.PARAMNAME}
                                        style={{
                                            // fontWeight: 'bolder',
                                            marginBottom: '0.2vh',
                                            fontFamily: '微软雅黑'
                                        }}
                                        key={item.PARAMNAME}
                                        rules={[
                                            { required: item.PARAMMAX && item.PARAMMIN, message: '请输入内容' },
                                            {
                                                validator(_, value) {
                                                    let max = item.PARAMMAX
                                                    let min = item.PARAMMIN
                                                    if (item.PARAMMAX && item.PARAMMIN) {
                                                        if (value < max && value > min) {
                                                            return Promise.resolve();
                                                        } else {
                                                            return Promise.reject(`取值范围` + min + `-` + max);
                                                        }
                                                    } else {
                                                        return Promise.resolve();
                                                    }

                                                },
                                            },
                                        ]}
                                    >

                                        <Input />

                                    </FormItem>
                                </Tooltip>
                            )
                        })
                    }
                </div>
            </div>

            <Divider />
            <div style={{ textAlign: 'left' }}>
                <FormItem
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}
                    label='开始时间'
                    style={{
                        // fontWeight: 'bolder',
                        marginBottom: '0.2vh',
                        fontFamily: '微软雅黑'
                    }}
                >
                    <Input style={{ minWidth: 100, maxWidth: 180 }} value={time(startTime)} />
                </FormItem>
                <Tooltip title='采集时间, 整数, 单位：分钟' placement="right" overlayStyle={{ maxWidth: 150, fontSize: 16 }}>
                    <FormItem
                        labelCol={{ span: 10 }}
                        wrapperCol={{ span: 14 }}
                        label='采集时间'
                        style={{
                            // fontWeight: 'bolder',
                            marginBottom: '0.2vh',
                            fontFamily: '微软雅黑'
                        }}
                    >
                        <Input style={{ minWidth: 100, maxWidth: 180 }} placeholder="mm" value={num} onChange={(e) => {
                            setNum(e.target.value)
                        }} />
                    </FormItem>
                </Tooltip>

            </div>

            <Divider />
            <Row gutter={[12, 16]} style={{ display: 'flex', }}>
                <Col>
                    <Button type="primary" htmlType="submit" size='large' disabled={btnStart}>开始</Button>
                </Col>

                <Col>
                    {/* <Button type="primary" size='large' disabled={btnStop} onClick={async () => {

                        var date: any = new Date();
                        setEndTime(date)
                        var FIVE_MIN = 1 * 60 * 1000;;
                        if ((date - startTime) > FIVE_MIN) {

                        } else {
                            message.warn('计算时间小于5分钟')
                            return
                        }

                        clearInterval(timeRef.current)
                        setNum(0)


                        setBtnStart(false)
                        setBtnStop(true)
                        setBtnReset(true)
                        setParamsDis(true)
                        setTableDis(false)
                        submit()
                    }}>
                        停止
                    </Button> */}
                    <Button size='large' style={{ marginLeft: 20 }} type='primary' disabled={btnReset} onClick={() => {

                        setStartTime('')
                        setEndTime('')
                        clearInterval(timeRef.current)
                        setNum(0)

                        setBtnReset(true)
                        setBtnStop(true)
                        setBtnStart(false)
                        setParamsDis(true)
                        setTableDis(false)
                    }}>重测</Button>
                </Col>
                <Col>
                    <Button type='primary' size='large' disabled={btnEdit} onClick={() => {
                        setBtnStart(true)
                        setBtnStop(true)
                        setBtnReset(true)
                        setBtnEdit(true)
                        setbtnResetSub(false)
                        setParamsDis(false)
                        setTableDis(false)

                        if (props.empty) {
                            props.empty(true)
                        }
                    }}>参数修改</Button>
                </Col>
                <Col style={{ marginLeft: 20 }}>
                    <Button type='primary' disabled={btnResetSub} htmlType="submit" size='large' >重新计算</Button>
                </Col>
                <Col><JobStatusViewer styled={{ width: '180px', height: '30px', marginLeft: '25px' }} /></Col>
            </Row>
            <Row style={{ marginTop: 20 }}>

            </Row>
            <Modal title="Basic Modal" visible={modelSHow} onOk={() => {
                setResetData(true)
                setModel(false)
            }} onCancel={() => {
                setModel(false)
                clearInterval(timeRef.current)
                setNum(0)
                setStartTime('')
                setBtnStart(false)
                setBtnStop(true)
                setBtnReset(true)




                setParamsDis(false)
                setTableDis(false)
            }}>
                <p>是否要进行重复提交？</p>

            </Modal>
        </Form>
    </RealTimeTitleBlock>
}

const mapStateToProps = (state: IState) => {
    const modules = state.progress.modules.modules;
    const activeIndex = state.progress.modules.activeIndex;
    return {
        module: modules[activeIndex],
        activeProject: state.project.activeName,
        username: state.user.userName,
        params: state.progress.params,
        lineName: state.progress.line.activeName,
    };
};

export default connect(
    mapStateToProps,
    { setActiveLine, updateLines, updateParam }
)(RealTimeParams);

